var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",staticClass:"tag-link",attrs:{"href":_vm.href,"to":_vm.to,"target":_vm.target}},[_c('TagItem',{attrs:{"text":_vm.text,"color":"white","icon-right":_vm.icon,"border":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }